import $ from 'jquery';
import setHeight from '../../scripts/util/dom/setHeight';
import resetClosestHeight from '../../scripts/util/dom/resetClosestHeight';

export default class SlideToggle {
	constructor() {
		this.selectors = {
			el: '.js-slide-el',
			toggle: '.js-slide-toggle',
			wrapper: '.js-slide-wrapper',
			mainWrapper: '.js-main-wrapper',
			content: '.js-slide-content'
		};

		this.classes = {
			open: 'slide-toggle_state_open',
			toggle: 'js-slide-toggle'
		};

		this.$el = $(this.selectors.el);
		this.$window = $(window);
	}

	getElements() {
		this.$toggle = $(this.selectors.toggle);
	}

	open($el, $wrapper, $content) {
		if ($el.hasClass(this.classes.open)) {
			return;
		}
		$el.addClass(this.classes.open);
		setHeight($wrapper, $content);
		resetClosestHeight($el, this.selectors.mainWrapper);
	}

	close($el, $wrapper) {
		$el.removeClass(this.classes.open);
		$wrapper.css('height', 0);
		resetClosestHeight($el, this.selectors.mainWrapper);
	}

	onClick(e) {
		const $target = $(e.target);
		const $el = $target.closest(this.selectors.el);
		const $wrapper = $el.find(this.selectors.wrapper);
		const $content = $el.find(this.selectors.content);

		if ($target.hasClass(this.classes.toggle)) {
			this.open($el, $wrapper, $content);
		} else {
			this.close($el, $wrapper);
		}
	}

	onResize() {
		const $open = $(`.${this.classes.open}`);
		$open.each((i, item) => {
			const $item = $(item);
			const $wrapper = $item.find(this.selectors.wrapper);
			const $content = $item.find(this.selectors.content);
			setHeight($wrapper, $content);
		});
	}

	render() {
		if (this.$el.length) {
			this.getElements();
			this.$toggle.on('click', e => this.onClick(e));
			this.$window.on('resize', () => this.onResize());
		}
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/slide-toggle/slide-toggle.js
 **/